export const getSalesListQuery = (initialLimit = 5, email) =>
  `{
        client_purchase_list(limit: ${initialLimit}, page: 1, returned: false, luxity_purchase_status: current, email: "${email}"){
            data{
                id
                order_number
                estimated_payout_date
                luxity_purchase {
                    purchase_status
                }
                purchase_order{
                    total
                    purchase_order_lines{
                        product{
                            image
                        }
                    }
                }
                payout_details {
                    type
                    link
                    date
                }
            }
            per_page
            total
            current_page
            last_page
            from
        }
    }`;
